var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navigationItem",class:[
    _vm.hoverClass,
    _vm.showText ? 'navigationItem--textExists' : 'navigationItem--iconOnly',
    { 'navigationItem--active': _vm.active }
  ]},[(_vm.icon)?_c('Icon',{staticClass:"navigationItem__icon",attrs:{"icon":_vm.icon,"color":_vm.iconColor,"size":_vm.size}}):_vm._e(),(_vm.hasCustomIconSlotContent)?_c('span',{staticClass:"navigationItem__icon navigationItem__customIcon"},[_vm._t("customicon")],2):_vm._e(),_c('Transition',{attrs:{"name":"navigationItemText"}},[(_vm.showText)?_c('div',{staticClass:"navigationItem__text"},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }